<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h5 class="mb-0">📰 Новости</h5>
        </div>
        
        <div v-if="loading" class="text-center py-3">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        
        <div v-else-if="news.length === 0" class="text-muted text-center py-3">
            Нет новостей для агентов 📭
        </div>
        
        <div v-else>
            <div 
                v-for="(item, index) in news" 
                :key="item.id" 
                class="news-item py-2 border-bottom"
                :class="{ 'mb-3': index !== news.length - 1 }"
                @click="openNewsDetail(item)"
            >
                <div class="d-flex align-items-start justify-content-between">
                    <div class="flex-grow-1">
                        <div class="font-weight-bold mb-1 cursor-pointer">{{ item.title || 'Без заголовка' }}</div>
                        <small class="text-muted">{{ formatDate(item.published_at) }}</small>
                        <div v-if="item.short_description" class="mt-1 text-muted small">
                            {{ item.short_description }}
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- <div class="text-center mt-3">
                <b-button 
                    variant="outline-secondary" 
                    size="sm"
                    @click="goToAllNews"
                >
                    📖 Все новости
                </b-button>
            </div> -->
        </div>

        <!-- Сайдбар для детального просмотра новости -->
        <NewsDetailSidebar
            v-model="sidebarOpen"
            :news="selectedNews"
            @close="onSidebarClose"
        />
    </div>
</template>

<script>
import { API_NEWS, HOST_FOR_STORAGE } from "@/constants";
import NewsDetailSidebar from './NewsDetailSidebar.vue';

export default {
    name: 'AgentNewsWidget',
    components: {
        NewsDetailSidebar
    },
    data() {
        return {
            hfs: HOST_FOR_STORAGE,
            loading: false,
            news: [],
            sidebarOpen: false,
            selectedNews: null
        }
    },
    mounted() {
        this.loadNews();
    },
    methods: {
        async loadNews() {
            this.loading = true;
            try {
                const response = await api.call('get', `${API_NEWS}/public?category=agents&limit=5`);
                this.news = response.data.data || [];
            } catch (error) {
                console.error('Ошибка загрузки новостей:', error);
                this.news = [];
            } finally {
                this.loading = false;
            }
        },
        
        formatDate(dateString) {
            if (!dateString) return '';
            
            // Если дата уже в формате d.m.Y H:i, просто возвращаем её
            if (typeof dateString === 'string' && dateString.match(/^\d{2}\.\d{2}\.\d{4}/)) {
                return dateString;
            }
            
            // Иначе пытаемся распарсить как ISO дату
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return dateString; // Возвращаем как есть, если не удалось распарсить
            }
            
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        

        
        openNewsDetail(news) {
            this.selectedNews = news;
            this.sidebarOpen = true;
            console.log('Открыта новость:', news); // Отладка
        },
        
        onSidebarClose() {
            this.selectedNews = null;
        },
        
        goToAllNews() {
            if (this.$router) {
                this.$router.push({ path: '/news', query: { category: 'agents' } }).catch(() => {});
            }
        },
        

    }
}
</script>

<style scoped>
.news-item {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.news-item:hover {
    background-color: #f8f9fa;
}

.cursor-pointer {
    cursor: pointer;
}


</style>
